import { offerResponseAppEventListener } from '../app-events/listeners/offerResponseAppEventListener.js';
import { transactionPaidAppEventListener } from '../app-events/listeners/transactionPaidAppEventListener.js';
import { config, canCallApp } from '../utils.js';
import * as $ from 'jquery';
import { onLoad } from '../utils/onLoad';
const EVENT_REPUBLISH = 'republish';

export const sendAppEvent = (event, params = {}) => {
    if (canCallApp('logEvent')) {
        setTimeout(() => Trendier.logEvent(event, JSON.stringify(params)), 1); // setTimeOut para esperar a que el webkit de IOS esté cargado
    }
    if (config?.environment !== 'production') {
        console.log(`App event ${event}`, params);
    }
};

offerResponseAppEventListener();
transactionPaidAppEventListener();

if (config[EVENT_REPUBLISH]) {
    sendAppEvent(EVENT_REPUBLISH, config[EVENT_REPUBLISH]);
}

$(document).on('submit', '.js-search-bar-header', event => sendAppEvent('search', {content: $(event.target).find('[name="txt"]').val()}));

$(document).on('click', '.js-heart.icon-heart', function () {
    const productId = $(this).closest('button').data('pid');
    if (!$('#json-product-' + productId).html()) {
        return;
    }
    const p = JSON.parse($('#json-product-' + productId).html());
    sendAppEvent('like', {
        product_id: p.id.toString(),
        price: parseFloat(p.price).toFixed(2),
        gender: "1",
        category: p.category,
        status: p.status,
        user_id_lister: p.owner,
        product_name: p.name,
        slug: p.slug,
        currency: config.currency,
        vertical: p.vertical
    });
});

//Comentarios ficha y parrilla
$(document).on('submit', '.js-comment-product,.add-comment-grid-form', function () {
    const productId = $(this).closest('form').find('[name="productId"]').val();
    const p = JSON.parse($('#json-product-' + productId).html());
    sendAppEvent('comment', {
        product_id: p.id.toString(),
        slug: p.slug,
        user_id_lister: p.owner,
        product_name: p.name,
        content: $(this).find("[name='txtcomment']").val(),
        category: p.category,
        vertical: p.vertical
    });
});


onLoad(() => {
    
    // is in product page
	if (document.querySelector('.product-sheet') ) {
		const productId = document.getElementById('product-sheet').dataset.idProduct;
		const p = JSON.parse($('#json-product-' + productId).html());
		sendAppEvent('product_view', {
			product_id: p.id.toString(),
			slug: p.slug,
			user_id_lister: p.owner,
			product_name: p.name,
			buyer_id: config.user? config.user.id : null,
			currency: config['currency'],
			price: p.price,
			category: p.category,
			primary_category: p.primaryCategory,
			vertical: p.vertical
		});
	}

    //Vistas checkout
	$('[data-ec-checkout-step]').each(function () {
		const p = JSON.parse($(this).find('.js-product-data').html());
		sendAppEvent(this.dataset.ecCheckoutStep == 1 ? 'add_to_cart' : 'add_to_cart2', {
			product_id: p.id.toString(),
			currency: config['currency'],
			price: p.price,
			gender: "1",
			category: p.category,
			primary_category: p.primaryCategory,
			status: p.status,
			brand: p.brand,
			user_id_lister: p.owner,
			product_name: p.name,
			slug: p.slug,
			isPointDeliveryAvailable: $('#isPointDeliveryAvailable').value,
			buyer_id: config.user? config.user.id : null,
			vertical: p.vertical
		});
	});

    document.querySelectorAll('[data-app-event-click]').forEach(input => {
		input.addEventListener('click', e => {
			sendAppEvent(input.getAttribute("data-app-event-click"), JSON.parse(input.getAttribute("data-app-event-params")));
		});
	});

});
